export default "/_next/static/images/fba7926800a2130d356d17ac6037fa2e.png";